
interface NavbarProps {
  isScrolled: boolean;
}

export default function Navbar({ isScrolled }: NavbarProps) {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-md' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('servicios')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-amber-500' : 'text-white hover:text-amber-400'}`}>
              Servicios
            </button>
            <button onClick={() => scrollToSection('nosotros')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-amber-500' : 'text-white hover:text-amber-400'}`}>
              Nosotros
            </button>
            <button onClick={() => scrollToSection('proyectos')} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${isScrolled ? 'text-gray-700 hover:text-amber-500' : 'text-white hover:text-amber-400'}`}>
              Proyectos
            </button>
            <button onClick={() => scrollToSection('contacto')} className="bg-amber-500 text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-amber-600 transition-colors whitespace-nowrap cursor-pointer">
              Contactar
            </button>
          </div>

          <button className={`md:hidden cursor-pointer ${isScrolled ? 'text-gray-700' : 'text-white'}`} onClick={() => {
            const menu = document.getElementById('mobile-menu');
            if (menu) {
              menu.classList.toggle('hidden');
            }
          }}>
            <i className="ri-menu-line text-2xl"></i>
          </button>
        </div>
      </div>

      <div id="mobile-menu" className="hidden md:hidden bg-white border-t border-gray-200">
        <div className="px-4 py-4 space-y-3">
          <button onClick={() => scrollToSection('servicios')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-amber-500 py-2 cursor-pointer">
            Servicios
          </button>
          <button onClick={() => scrollToSection('nosotros')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-amber-500 py-2 cursor-pointer">
            Nosotros
          </button>
          <button onClick={() => scrollToSection('proyectos')} className="block w-full text-left text-sm font-medium text-gray-700 hover:text-amber-500 py-2 cursor-pointer">
            Proyectos
          </button>
          <button onClick={() => scrollToSection('contacto')} className="bg-amber-500 text-white px-6 py-2.5 rounded-lg text-sm font-semibold hover:bg-amber-600 transition-colors w-full whitespace-nowrap cursor-pointer">
            Contactar
          </button>
        </div>
      </div>
    </nav>
  );
}
